import { render } from "./DraftSelection.vue?vue&type=template&id=17d203e4&scoped=true"
import script from "./DraftSelection.vue?vue&type=script&lang=js"
export * from "./DraftSelection.vue?vue&type=script&lang=js"

import "./DraftSelection.vue?vue&type=style&index=0&id=17d203e4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\knhmb\\Documents\\Khalid\\Job\\MarvelConnect Technology\\Projects\\One Shop Online Shopping\\one-shop-online-shopping\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17d203e4"]])

export default __exports__